<template>
  <!-- Title of the box -->
  <v-layout>
    <v-row>
      <v-col class="py-0 pl-0 ma-1">
        <v-card ref="form" width="100%">
          <div>
            <span v-html="title"></span>
          </div>
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="data.pnkh"
            label="ឈ្មោះជាអក្សរខ្មែរ"
          />
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="data.pnen"
            label="ឈ្មោះជាអក្សរឡាតាំង"
          />
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="data.ofid"
            label="អត្តលេខមន្ត្រីរាជការ"
          />
          <v-text-field
            class="ttext my-0 px-1"
            placeholder="dd-mm-yyyy"
            :rules="[rules.dob]"
            outline
            v-model="data.dob"
            label="ថ្ងៃ ខែ ឆ្នាំកំណើត"
          />
          <v-select
            class="px-1"
            v-model="data.gen"
            :items="gender"
            item-text="text"
            item-value="value"
            outline
            label="ភេទ"
            hide-details
            @keypress.native="onSelect1($event)"
          >
          </v-select>
          <v-select
            class="px-1"
            v-model="data.educ"
            :items="degree"
            item-text="text"
            item-value="value"
            outline
            label="កម្រិតវប្បធម៌ខ្ពស់បំផុត"
            hide-details
            @keypress.native="onSelect3($event)"
          >
          </v-select>
          <v-select
            class="px-1"
            v-model="data.rete"
            :items="rp"
            item-text="text"
            item-value="value"
            outline
            label="បើជានាយកជំនួស"
            hide-details
            @keypress.native="onSelect2($event)"
          >
          </v-select>
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="data.tose"
            type="number"
            :rules="[rules.required]"
            label="សរុបចំនួនឆ្នាំបម្រើការងារអប់រំ"
          />
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="data.prse"
            type="number"
            :rules="[rules.required]"
            label="ចំនួនឆ្នាំបម្រើការងារជានាយក"
          />
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="data.teho"
            type="number"
            :rules="[rules.required]"
            label="ចំនួនម៉ោងបង្រៀនក្នុង១សប្ដាហ៍"
          />
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="data.phnu"
            label="លេខទូរស័ព្ទរបស់នាយក/នាយិកា"
          />
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="data.phnu"
            label="សារអេឡិចត្រូនិច (E-mail)"
          />
        </v-card>
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
import {
  maleFemale,
  replacePrinciple,
  degree,
} from "@/utils/ascf/commonConfig.js";

export default {
  props: ["data", "title"],
  data() {
    return {
      gender: maleFemale,
      rp: replacePrinciple,
      degree: degree,
      rules: {
        // :rules="[rules.required, rules.email]"
        required: (value) => !!value || "Required.",
        dob: (value) => {
          const pattern = /^(0[1-9]|[12][0-9]|3[01])[-/.](0[1-9]|1[012])[-/.](19|20)\d\d$/;
          if (pattern.test(value)) {
            return true;
          } else {
            return "សូមវាយទំរង់ dd-mm-yyyy";
          }
        },
      },
    };
  },
  methods: {
    onSelect1: function (event) {
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 50) {
        this.data.gen = charCode - 48;
        this.$forceUpdate();
      }
    },
    onSelect2: function (event) {
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 50) {
        this.data.rete = charCode - 48;
        this.$forceUpdate();
      }
    },
    onSelect3: function (event) {
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 57) {
        this.data.educ = charCode - 48;
        this.$forceUpdate();
      }
    },
  },
};
</script>

<style scoped>
.ttext {
  font-family: "Siemreap";
  font-size: 12px;
}
.input-group--select >>> .input-group__selections__comma {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 12px;
  padding: 1px 1px 1px 0;
}
.v-input {
  font-size: 12px;
}
</style>